webpackJsonp([1,5,11,26,27,28,30,31,32,33,34],{

/***/ 10:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* WEBPACK VAR INJECTION */(function($) {var _this = this;

var setupSubmitOnEnter = function setupSubmitOnEnter() {
  $('.search-text-submit-field').keypress(function (e) {
    if (e.which === 13) {
      $(_this).closest('form').submit();
    }
  });
};
/* harmony default export */ __webpack_exports__["default"] = (setupSubmitOnEnter);
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(0)))

/***/ }),

/***/ 11:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* WEBPACK VAR INJECTION */(function($) {var openModal = function openModal() {
  var button = $('[data-event="modal"]');

  button.on('click', function (event) {
    event.preventDefault();
    var target = button.data('target');
    $(target).addClass('modal--active');
  });
};

var closeModal = function closeModal() {
  var button = $('[data-event="modal-close"]');

  button.on('click', function (event) {
    event.preventDefault();
    var modal = button.parents('.modal');
    $(modal).removeClass('modal--active');
  });
};

var modalModule = function modalModule() {
  openModal();
  closeModal();
};
/* harmony default export */ __webpack_exports__["default"] = (modalModule);
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(0)))

/***/ }),

/***/ 12:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* WEBPACK VAR INJECTION */(function($) {var closeAlertMessage = function closeAlertMessage() {
  return $('.notification__icon').on('click', function () {
    $(this).parent().remove();
  });
};

/* harmony default export */ __webpack_exports__["default"] = (closeAlertMessage);
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(0)))

/***/ }),

/***/ 19:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__cart__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__menuHamburger__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__toggleMenu__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__submit__ = __webpack_require__(10);





var HeaderModule = function HeaderModule() {
  // Header
  Object(__WEBPACK_IMPORTED_MODULE_1__menuHamburger__["default"])();
  Object(__WEBPACK_IMPORTED_MODULE_2__toggleMenu__["default"])();
  Object(__WEBPACK_IMPORTED_MODULE_0__cart__["initializeMenuCheckout"])();
  Object(__WEBPACK_IMPORTED_MODULE_0__cart__["addToCartWhenClick"])();
  Object(__WEBPACK_IMPORTED_MODULE_3__submit__["default"])();
  Object(__WEBPACK_IMPORTED_MODULE_0__cart__["disableButtonWhenItemIsOnCart"])();
};
/* harmony default export */ __webpack_exports__["default"] = (HeaderModule);

/***/ }),

/***/ 20:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* WEBPACK VAR INJECTION */(function($) {var setupFilters = function setupFilters() {
  $('.form_filter').on('change', function () {
    $(this).closest('form').submit();
  });
};
/* harmony default export */ __webpack_exports__["default"] = (setupFilters);
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(0)))

/***/ }),

/***/ 21:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* WEBPACK VAR INJECTION */(function($) {var limitPagination = function limitPagination() {
  $('.limit_pagination').on('change', function () {
    $(this).closest('form').submit();
  });
};
/* harmony default export */ __webpack_exports__["default"] = (limitPagination);
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(0)))

/***/ }),

/***/ 22:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__modal__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__alert_message__ = __webpack_require__(12);



var ComponentsModule = function ComponentsModule() {
  Object(__WEBPACK_IMPORTED_MODULE_0__modal__["default"])();
  Object(__WEBPACK_IMPORTED_MODULE_1__alert_message__["default"])();
};

/* harmony default export */ __webpack_exports__["default"] = (ComponentsModule);

/***/ }),

/***/ 48:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_jquery_ujs__ = __webpack_require__(49);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_jquery_ujs___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_jquery_ujs__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__common_header__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__common_filters__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__common_pagination__ = __webpack_require__(21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_components__ = __webpack_require__(22);







document.addEventListener('DOMContentLoaded', function () {
  // Components
  Object(__WEBPACK_IMPORTED_MODULE_4__components_components__["default"])();
  // Header
  Object(__WEBPACK_IMPORTED_MODULE_1__common_header__["default"])();
  // Paginations Limit Handler 
  Object(__WEBPACK_IMPORTED_MODULE_3__common_pagination__["default"])();
  // set filter
  Object(__WEBPACK_IMPORTED_MODULE_2__common_filters__["default"])();
});

/***/ }),

/***/ 49:
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(jQuery) {(function($, undefined) {

/**
 * Unobtrusive scripting adapter for jQuery
 * https://github.com/rails/jquery-ujs
 *
 * Requires jQuery 1.8.0 or later.
 *
 * Released under the MIT license
 *
 */

  // Cut down on the number of issues from people inadvertently including jquery_ujs twice
  // by detecting and raising an error when it happens.
  'use strict';

  if ( $.rails !== undefined ) {
    $.error('jquery-ujs has already been loaded!');
  }

  // Shorthand to make it a little easier to call public rails functions from within rails.js
  var rails;
  var $document = $(document);

  $.rails = rails = {
    // Link elements bound by jquery-ujs
    linkClickSelector: 'a[data-confirm], a[data-method], a[data-remote]:not([disabled]), a[data-disable-with], a[data-disable]',

    // Button elements bound by jquery-ujs
    buttonClickSelector: 'button[data-remote]:not([form]):not(form button), button[data-confirm]:not([form]):not(form button)',

    // Select elements bound by jquery-ujs
    inputChangeSelector: 'select[data-remote], input[data-remote], textarea[data-remote]',

    // Form elements bound by jquery-ujs
    formSubmitSelector: 'form',

    // Form input elements bound by jquery-ujs
    formInputClickSelector: 'form input[type=submit], form input[type=image], form button[type=submit], form button:not([type]), input[type=submit][form], input[type=image][form], button[type=submit][form], button[form]:not([type])',

    // Form input elements disabled during form submission
    disableSelector: 'input[data-disable-with]:enabled, button[data-disable-with]:enabled, textarea[data-disable-with]:enabled, input[data-disable]:enabled, button[data-disable]:enabled, textarea[data-disable]:enabled',

    // Form input elements re-enabled after form submission
    enableSelector: 'input[data-disable-with]:disabled, button[data-disable-with]:disabled, textarea[data-disable-with]:disabled, input[data-disable]:disabled, button[data-disable]:disabled, textarea[data-disable]:disabled',

    // Form required input elements
    requiredInputSelector: 'input[name][required]:not([disabled]), textarea[name][required]:not([disabled])',

    // Form file input elements
    fileInputSelector: 'input[name][type=file]:not([disabled])',

    // Link onClick disable selector with possible reenable after remote submission
    linkDisableSelector: 'a[data-disable-with], a[data-disable]',

    // Button onClick disable selector with possible reenable after remote submission
    buttonDisableSelector: 'button[data-remote][data-disable-with], button[data-remote][data-disable]',

    // Up-to-date Cross-Site Request Forgery token
    csrfToken: function() {
     return $('meta[name=csrf-token]').attr('content');
    },

    // URL param that must contain the CSRF token
    csrfParam: function() {
     return $('meta[name=csrf-param]').attr('content');
    },

    // Make sure that every Ajax request sends the CSRF token
    CSRFProtection: function(xhr) {
      var token = rails.csrfToken();
      if (token) xhr.setRequestHeader('X-CSRF-Token', token);
    },

    // Make sure that all forms have actual up-to-date tokens (cached forms contain old ones)
    refreshCSRFTokens: function(){
      $('form input[name="' + rails.csrfParam() + '"]').val(rails.csrfToken());
    },

    // Triggers an event on an element and returns false if the event result is false
    fire: function(obj, name, data) {
      var event = $.Event(name);
      obj.trigger(event, data);
      return event.result !== false;
    },

    // Default confirm dialog, may be overridden with custom confirm dialog in $.rails.confirm
    confirm: function(message) {
      return confirm(message);
    },

    // Default ajax function, may be overridden with custom function in $.rails.ajax
    ajax: function(options) {
      return $.ajax(options);
    },

    // Default way to get an element's href. May be overridden at $.rails.href.
    href: function(element) {
      return element[0].href;
    },

    // Checks "data-remote" if true to handle the request through a XHR request.
    isRemote: function(element) {
      return element.data('remote') !== undefined && element.data('remote') !== false;
    },

    // Submits "remote" forms and links with ajax
    handleRemote: function(element) {
      var method, url, data, withCredentials, dataType, options;

      if (rails.fire(element, 'ajax:before')) {
        withCredentials = element.data('with-credentials') || null;
        dataType = element.data('type') || ($.ajaxSettings && $.ajaxSettings.dataType);

        if (element.is('form')) {
          method = element.data('ujs:submit-button-formmethod') || element.attr('method');
          url = element.data('ujs:submit-button-formaction') || element.attr('action');
          data = $(element[0]).serializeArray();
          // memoized value from clicked submit button
          var button = element.data('ujs:submit-button');
          if (button) {
            data.push(button);
            element.data('ujs:submit-button', null);
          }
          element.data('ujs:submit-button-formmethod', null);
          element.data('ujs:submit-button-formaction', null);
        } else if (element.is(rails.inputChangeSelector)) {
          method = element.data('method');
          url = element.data('url');
          data = element.serialize();
          if (element.data('params')) data = data + '&' + element.data('params');
        } else if (element.is(rails.buttonClickSelector)) {
          method = element.data('method') || 'get';
          url = element.data('url');
          data = element.serialize();
          if (element.data('params')) data = data + '&' + element.data('params');
        } else {
          method = element.data('method');
          url = rails.href(element);
          data = element.data('params') || null;
        }

        options = {
          type: method || 'GET', data: data, dataType: dataType,
          // stopping the "ajax:beforeSend" event will cancel the ajax request
          beforeSend: function(xhr, settings) {
            if (settings.dataType === undefined) {
              xhr.setRequestHeader('accept', '*/*;q=0.5, ' + settings.accepts.script);
            }
            if (rails.fire(element, 'ajax:beforeSend', [xhr, settings])) {
              element.trigger('ajax:send', xhr);
            } else {
              return false;
            }
          },
          success: function(data, status, xhr) {
            element.trigger('ajax:success', [data, status, xhr]);
          },
          complete: function(xhr, status) {
            element.trigger('ajax:complete', [xhr, status]);
          },
          error: function(xhr, status, error) {
            element.trigger('ajax:error', [xhr, status, error]);
          },
          crossDomain: rails.isCrossDomain(url)
        };

        // There is no withCredentials for IE6-8 when
        // "Enable native XMLHTTP support" is disabled
        if (withCredentials) {
          options.xhrFields = {
            withCredentials: withCredentials
          };
        }

        // Only pass url to `ajax` options if not blank
        if (url) { options.url = url; }

        return rails.ajax(options);
      } else {
        return false;
      }
    },

    // Determines if the request is a cross domain request.
    isCrossDomain: function(url) {
      var originAnchor = document.createElement('a');
      originAnchor.href = location.href;
      var urlAnchor = document.createElement('a');

      try {
        urlAnchor.href = url;
        // This is a workaround to a IE bug.
        urlAnchor.href = urlAnchor.href;

        // If URL protocol is false or is a string containing a single colon
        // *and* host are false, assume it is not a cross-domain request
        // (should only be the case for IE7 and IE compatibility mode).
        // Otherwise, evaluate protocol and host of the URL against the origin
        // protocol and host.
        return !(((!urlAnchor.protocol || urlAnchor.protocol === ':') && !urlAnchor.host) ||
          (originAnchor.protocol + '//' + originAnchor.host ===
            urlAnchor.protocol + '//' + urlAnchor.host));
      } catch (e) {
        // If there is an error parsing the URL, assume it is crossDomain.
        return true;
      }
    },

    // Handles "data-method" on links such as:
    // <a href="/users/5" data-method="delete" rel="nofollow" data-confirm="Are you sure?">Delete</a>
    handleMethod: function(link) {
      var href = rails.href(link),
        method = link.data('method'),
        target = link.attr('target'),
        csrfToken = rails.csrfToken(),
        csrfParam = rails.csrfParam(),
        form = $('<form method="post" action="' + href + '"></form>'),
        metadataInput = '<input name="_method" value="' + method + '" type="hidden" />';

      if (csrfParam !== undefined && csrfToken !== undefined && !rails.isCrossDomain(href)) {
        metadataInput += '<input name="' + csrfParam + '" value="' + csrfToken + '" type="hidden" />';
      }

      if (target) { form.attr('target', target); }

      form.hide().append(metadataInput).appendTo('body');
      form.submit();
    },

    // Helper function that returns form elements that match the specified CSS selector
    // If form is actually a "form" element this will return associated elements outside the from that have
    // the html form attribute set
    formElements: function(form, selector) {
      return form.is('form') ? $(form[0].elements).filter(selector) : form.find(selector);
    },

    /* Disables form elements:
      - Caches element value in 'ujs:enable-with' data store
      - Replaces element text with value of 'data-disable-with' attribute
      - Sets disabled property to true
    */
    disableFormElements: function(form) {
      rails.formElements(form, rails.disableSelector).each(function() {
        rails.disableFormElement($(this));
      });
    },

    disableFormElement: function(element) {
      var method, replacement;

      method = element.is('button') ? 'html' : 'val';
      replacement = element.data('disable-with');

      if (replacement !== undefined) {
        element.data('ujs:enable-with', element[method]());
        element[method](replacement);
      }

      element.prop('disabled', true);
      element.data('ujs:disabled', true);
    },

    /* Re-enables disabled form elements:
      - Replaces element text with cached value from 'ujs:enable-with' data store (created in `disableFormElements`)
      - Sets disabled property to false
    */
    enableFormElements: function(form) {
      rails.formElements(form, rails.enableSelector).each(function() {
        rails.enableFormElement($(this));
      });
    },

    enableFormElement: function(element) {
      var method = element.is('button') ? 'html' : 'val';
      if (element.data('ujs:enable-with') !== undefined) {
        element[method](element.data('ujs:enable-with'));
        element.removeData('ujs:enable-with'); // clean up cache
      }
      element.prop('disabled', false);
      element.removeData('ujs:disabled');
    },

   /* For 'data-confirm' attribute:
      - Fires `confirm` event
      - Shows the confirmation dialog
      - Fires the `confirm:complete` event

      Returns `true` if no function stops the chain and user chose yes; `false` otherwise.
      Attaching a handler to the element's `confirm` event that returns a `falsy` value cancels the confirmation dialog.
      Attaching a handler to the element's `confirm:complete` event that returns a `falsy` value makes this function
      return false. The `confirm:complete` event is fired whether or not the user answered true or false to the dialog.
   */
    allowAction: function(element) {
      var message = element.data('confirm'),
          answer = false, callback;
      if (!message) { return true; }

      if (rails.fire(element, 'confirm')) {
        try {
          answer = rails.confirm(message);
        } catch (e) {
          (console.error || console.log).call(console, e.stack || e);
        }
        callback = rails.fire(element, 'confirm:complete', [answer]);
      }
      return answer && callback;
    },

    // Helper function which checks for blank inputs in a form that match the specified CSS selector
    blankInputs: function(form, specifiedSelector, nonBlank) {
      var foundInputs = $(),
        input,
        valueToCheck,
        radiosForNameWithNoneSelected,
        radioName,
        selector = specifiedSelector || 'input,textarea',
        requiredInputs = form.find(selector),
        checkedRadioButtonNames = {};

      requiredInputs.each(function() {
        input = $(this);
        if (input.is('input[type=radio]')) {

          // Don't count unchecked required radio as blank if other radio with same name is checked,
          // regardless of whether same-name radio input has required attribute or not. The spec
          // states https://www.w3.org/TR/html5/forms.html#the-required-attribute
          radioName = input.attr('name');

          // Skip if we've already seen the radio with this name.
          if (!checkedRadioButtonNames[radioName]) {

            // If none checked
            if (form.find('input[type=radio]:checked[name="' + radioName + '"]').length === 0) {
              radiosForNameWithNoneSelected = form.find(
                'input[type=radio][name="' + radioName + '"]');
              foundInputs = foundInputs.add(radiosForNameWithNoneSelected);
            }

            // We only need to check each name once.
            checkedRadioButtonNames[radioName] = radioName;
          }
        } else {
          valueToCheck = input.is('input[type=checkbox],input[type=radio]') ? input.is(':checked') : !!input.val();
          if (valueToCheck === nonBlank) {
            foundInputs = foundInputs.add(input);
          }
        }
      });
      return foundInputs.length ? foundInputs : false;
    },

    // Helper function which checks for non-blank inputs in a form that match the specified CSS selector
    nonBlankInputs: function(form, specifiedSelector) {
      return rails.blankInputs(form, specifiedSelector, true); // true specifies nonBlank
    },

    // Helper function, needed to provide consistent behavior in IE
    stopEverything: function(e) {
      $(e.target).trigger('ujs:everythingStopped');
      e.stopImmediatePropagation();
      return false;
    },

    //  Replace element's html with the 'data-disable-with' after storing original html
    //  and prevent clicking on it
    disableElement: function(element) {
      var replacement = element.data('disable-with');

      if (replacement !== undefined) {
        element.data('ujs:enable-with', element.html()); // store enabled state
        element.html(replacement);
      }

      element.bind('click.railsDisable', function(e) { // prevent further clicking
        return rails.stopEverything(e);
      });
      element.data('ujs:disabled', true);
    },

    // Restore element to its original state which was disabled by 'disableElement' above
    enableElement: function(element) {
      if (element.data('ujs:enable-with') !== undefined) {
        element.html(element.data('ujs:enable-with')); // set to old enabled state
        element.removeData('ujs:enable-with'); // clean up cache
      }
      element.unbind('click.railsDisable'); // enable element
      element.removeData('ujs:disabled');
    }
  };

  if (rails.fire($document, 'rails:attachBindings')) {

    $.ajaxPrefilter(function(options, originalOptions, xhr){ if ( !options.crossDomain ) { rails.CSRFProtection(xhr); }});

    // This event works the same as the load event, except that it fires every
    // time the page is loaded.
    //
    // See https://github.com/rails/jquery-ujs/issues/357
    // See https://developer.mozilla.org/en-US/docs/Using_Firefox_1.5_caching
    $(window).on('pageshow.rails', function () {
      $($.rails.enableSelector).each(function () {
        var element = $(this);

        if (element.data('ujs:disabled')) {
          $.rails.enableFormElement(element);
        }
      });

      $($.rails.linkDisableSelector).each(function () {
        var element = $(this);

        if (element.data('ujs:disabled')) {
          $.rails.enableElement(element);
        }
      });
    });

    $document.on('ajax:complete', rails.linkDisableSelector, function() {
        rails.enableElement($(this));
    });

    $document.on('ajax:complete', rails.buttonDisableSelector, function() {
        rails.enableFormElement($(this));
    });

    $document.on('click.rails', rails.linkClickSelector, function(e) {
      var link = $(this), method = link.data('method'), data = link.data('params'), metaClick = e.metaKey || e.ctrlKey;
      if (!rails.allowAction(link)) return rails.stopEverything(e);

      if (!metaClick && link.is(rails.linkDisableSelector)) rails.disableElement(link);

      if (rails.isRemote(link)) {
        if (metaClick && (!method || method === 'GET') && !data) { return true; }

        var handleRemote = rails.handleRemote(link);
        // Response from rails.handleRemote() will either be false or a deferred object promise.
        if (handleRemote === false) {
          rails.enableElement(link);
        } else {
          handleRemote.fail( function() { rails.enableElement(link); } );
        }
        return false;

      } else if (method) {
        rails.handleMethod(link);
        return false;
      }
    });

    $document.on('click.rails', rails.buttonClickSelector, function(e) {
      var button = $(this);

      if (!rails.allowAction(button) || !rails.isRemote(button)) return rails.stopEverything(e);

      if (button.is(rails.buttonDisableSelector)) rails.disableFormElement(button);

      var handleRemote = rails.handleRemote(button);
      // Response from rails.handleRemote() will either be false or a deferred object promise.
      if (handleRemote === false) {
        rails.enableFormElement(button);
      } else {
        handleRemote.fail( function() { rails.enableFormElement(button); } );
      }
      return false;
    });

    $document.on('change.rails', rails.inputChangeSelector, function(e) {
      var link = $(this);
      if (!rails.allowAction(link) || !rails.isRemote(link)) return rails.stopEverything(e);

      rails.handleRemote(link);
      return false;
    });

    $document.on('submit.rails', rails.formSubmitSelector, function(e) {
      var form = $(this),
        remote = rails.isRemote(form),
        blankRequiredInputs,
        nonBlankFileInputs;

      if (!rails.allowAction(form)) return rails.stopEverything(e);

      // Skip other logic when required values are missing or file upload is present
      if (form.attr('novalidate') === undefined) {
        if (form.data('ujs:formnovalidate-button') === undefined) {
          blankRequiredInputs = rails.blankInputs(form, rails.requiredInputSelector, false);
          if (blankRequiredInputs && rails.fire(form, 'ajax:aborted:required', [blankRequiredInputs])) {
            return rails.stopEverything(e);
          }
        } else {
          // Clear the formnovalidate in case the next button click is not on a formnovalidate button
          // Not strictly necessary to do here, since it is also reset on each button click, but just to be certain
          form.data('ujs:formnovalidate-button', undefined);
        }
      }

      if (remote) {
        nonBlankFileInputs = rails.nonBlankInputs(form, rails.fileInputSelector);
        if (nonBlankFileInputs) {
          // Slight timeout so that the submit button gets properly serialized
          // (make it easy for event handler to serialize form without disabled values)
          setTimeout(function(){ rails.disableFormElements(form); }, 13);
          var aborted = rails.fire(form, 'ajax:aborted:file', [nonBlankFileInputs]);

          // Re-enable form elements if event bindings return false (canceling normal form submission)
          if (!aborted) { setTimeout(function(){ rails.enableFormElements(form); }, 13); }

          return aborted;
        }

        rails.handleRemote(form);
        return false;

      } else {
        // Slight timeout so that the submit button gets properly serialized
        setTimeout(function(){ rails.disableFormElements(form); }, 13);
      }
    });

    $document.on('click.rails', rails.formInputClickSelector, function(event) {
      var button = $(this);

      if (!rails.allowAction(button)) return rails.stopEverything(event);

      // Register the pressed submit button
      var name = button.attr('name'),
        data = name ? {name:name, value:button.val()} : null;

      var form = button.closest('form');
      if (form.length === 0) {
        form = $('#' + button.attr('form'));
      }
      form.data('ujs:submit-button', data);

      // Save attributes from button
      form.data('ujs:formnovalidate-button', button.attr('formnovalidate'));
      form.data('ujs:submit-button-formaction', button.attr('formaction'));
      form.data('ujs:submit-button-formmethod', button.attr('formmethod'));
    });

    $document.on('ajax:send.rails', rails.formSubmitSelector, function(event) {
      if (this === event.target) rails.disableFormElements($(this));
    });

    $document.on('ajax:complete.rails', rails.formSubmitSelector, function(event) {
      if (this === event.target) rails.enableFormElements($(this));
    });

    $(function(){
      rails.refreshCSRFTokens();
    });
  }

})( jQuery );

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(0)))

/***/ }),

/***/ 7:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* WEBPACK VAR INJECTION */(function($) {/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "disableButtonWhenItemIsOnCart", function() { return disableButtonWhenItemIsOnCart; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "initializeMenuCheckout", function() { return initializeMenuCheckout; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "addToCartWhenClick", function() { return addToCartWhenClick; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_loading__ = __webpack_require__(5);


var toogleMenuCheckoutWhenClick = function toogleMenuCheckoutWhenClick() {
  var chekoutClickableButton = $('.menu-checkout__icon');
  var checkoutButton = $('.menu-checkout');

  chekoutClickableButton.on('click', function () {
    var checkoutEmpty = parseInt($('.menu-checkout').attr('data-item'), 10) === 0;

    if (checkoutEmpty) {
      checkoutButton.toggleClass('menu-checkout--empty');
    } else {
      checkoutButton.toggleClass('menu-checkout--items');
    }
  });
};

var closeCartMenu = function closeCartMenu() {
  var checkoutButton = $('.menu-checkout');

  checkoutButton.removeClass('menu-checkout--items');
  checkoutButton.removeClass('menu-checkout--empty');
  checkoutButton.removeClass('menu-checkout--model');
};

var removeFromCartWhenClick = function removeFromCartWhenClick() {
  var removeFromCartButton = $('.remove_cart_item');
  removeFromCartButton.on('click', function (e) {
    var url = $(this).data('url');
    var li = $(this).closest('li');

    $.getJSON(url, function (data) {
      if (data.success) {
        var checkoutButton = $('.menu-checkout');
        var items = $('.add_cart_button');
        checkoutButton.attr('data-item', data.count);

        items.each(function (i) {
          if (items[i].dataset.currentItem === e.target.dataset.currentItem) {
            items[i].style.display = 'flex';
          }
        });

        if (data.count === 0 && checkoutButton.hasClass('menu-checkout--items')) {
          checkoutButton.removeClass('menu-checkout--items');
          checkoutButton.addClass('menu-checkout--empty');
        }

        li.remove();
      }
    });

    e.preventDefault();
  });
};

var closeMenuCheckoutWhenClickOutside = function closeMenuCheckoutWhenClickOutside() {
  var checkoutButton = $('.menu-checkout');

  $(document).on('click', function (event) {
    if (!$(event.target).closest(checkoutButton).length) {
      closeCartMenu();
    }
  });
};

var closeMenuCheckoutWhenClick = function closeMenuCheckoutWhenClick() {
  var checkoutCloseButton = $('.close_cart_menu');

  checkoutCloseButton.on('click', function () {
    closeCartMenu();
  });
};

var reloadMenuCheckout = function reloadMenuCheckout() {
  toogleMenuCheckoutWhenClick();
  closeMenuCheckoutWhenClick();
  removeFromCartWhenClick();
};

var showAddedItem = function showAddedItem() {
  var checkoutButton = $('.menu-checkout');
  checkoutButton.removeClass('menu-checkout--items');
  checkoutButton.removeClass('menu-checkout--empty');
  checkoutButton.addClass('menu-checkout--model');

  var showCartButton = $('.close_item_show_cart');
  showCartButton.on('click', function () {
    checkoutButton.removeClass('menu-checkout--model');
    checkoutButton.addClass('menu-checkout--items');
  });
};

var addToCartWhenClick = function addToCartWhenClick() {
  $('body').on('click', '.add_cart_button', function (e) {
    e.preventDefault();
    var url = $(this).attr('href');
    Object(__WEBPACK_IMPORTED_MODULE_0__components_loading__["showLoading"])();

    $.getJSON(url, function (data) {
      if (data.redirect_to) {
        window.location = data.redirect_to;
        return;
      }

      var checkoutButton = $('.menu-checkout');
      var items = $('.add_cart_button');

      // Hidden button when add item to cart
      // e.target.parentElement.style.display = 'none';

      items.each(function (i) {
        if (items[i].dataset.currentItem === e.target.dataset.currentItem) {
          items[i].style.display = 'none';
        }
      });

      checkoutButton.html(data.render);
      checkoutButton.attr('data-item', data.count);

      reloadMenuCheckout();
      showAddedItem();
    }).done(function () {
      Object(__WEBPACK_IMPORTED_MODULE_0__components_loading__["stopLoading"])();
    }).fail(function (xhr) {
      Object(__WEBPACK_IMPORTED_MODULE_0__components_loading__["stopLoading"])();

      if (xhr.status === 401 && xhr.responseJSON && xhr.responseJSON.login_url) {
        window.location = xhr.responseJSON.login_url;
      }
    });

    e.preventDefault();
  });
};

var disableButtonWhenItemIsOnCart = function disableButtonWhenItemIsOnCart() {
  var buttonContainer = $('.add_cart_button');

  buttonContainer.each(function (e) {
    if (buttonContainer[e].dataset.showButton === 'true') {
      buttonContainer[e].style.display = 'none';
    }
  });
};

var initializeMenuCheckout = function initializeMenuCheckout() {
  toogleMenuCheckoutWhenClick();
  closeMenuCheckoutWhenClick();
  closeMenuCheckoutWhenClickOutside();
  removeFromCartWhenClick();
};


/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(0)))

/***/ }),

/***/ 8:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* WEBPACK VAR INJECTION */(function($) {var menuFn = function menuFn() {
  var config = 100;
  var wrapperNav = $('.wrapper-nav');
  var toggleButton = $('.menu__toggle');
  var containerMobile = $('.wrapper-nav .container');
  var navList = $('.menu-items');
  var path = window.location.pathname;
  var menuItem = $('.hamburger');
  var position = 0;

  if (path === '/') {
    $(window).scroll(function () {
      // get current position
      position = $(this).scrollTop();

      /*
      * verifies that the current position is greater than the configured position,
      * if it adds the `nav--fixed` class
      */
      if (position > config) {
        wrapperNav.addClass('nav--fixed');
        wrapperNav.find('.button--outline').removeClass('button--white').addClass('button--default');
      } else {
        wrapperNav.removeClass('nav--fixed');
        wrapperNav.find('.button--outline').removeClass('button--default').addClass('button--white');
      }
    }).scroll();
  }

  toggleButton.on('click', function () {
    menuItem.toggleClass('is-active');

    if (!navList.hasClass('active')) {
      navList.addClass('active');
    } else {
      navList.removeClass('active');
    }
  });

  $(window).resize(function () {
    var windowWidth = window.innerWidth;

    if (windowWidth > 767) {
      navList.removeClass('active');
      toggleButton.removeClass('active');
      containerMobile.removeClass('container--mobile');
      menuItem.removeClass('is-active');
    } else {
      containerMobile.addClass('container--mobile');
    }
  }).resize();
};

/* harmony default export */ __webpack_exports__["default"] = (menuFn);
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(0)))

/***/ }),

/***/ 9:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* WEBPACK VAR INJECTION */(function($) {// @TODO dividir esse arquivo
var toggleMenu = function toggleMenu() {
  $('.menu-collapse__submenu').on('click', 'a', function (e) {
    return e.stopPropagation();
  });

  var menu = $('.menu-collapse__item');
  menu.on('click', 'a', function (e) {
    var submenuItem = $(this).parents('.menu-collapse__item');
    var submenu = submenuItem.find('.menu-collapse__submenu');
    var submenuExists = submenu.length === 1;

    if (submenuExists) {
      submenuItem.toggleClass('active');

      if (submenuItem.hasClass('active')) {
        setTimeout(function () {
          submenu.addClass('overflow-animation');
        }, 400);
      } else {
        submenu.removeClass('overflow-animation');
      }

      e.preventDefault();
    }
  });
};

/* harmony default export */ __webpack_exports__["default"] = (toggleMenu);
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(0)))

/***/ })

},[48]);


// WEBPACK FOOTER //
// application-fea426e0cab30e97a5c1.js